import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSesion from 'vue-session';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false;
window.$ = require('jquery')
Vue.use(VueSesion)
Vue.use(VueCookies) 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')